import './App.css';
import { Outlet } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { translationService } from './services/translationService';
import { getPreferredLanguage } from './utils/languageUtil';

export function App() {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const initializeLanguage = async () => {
            try {
                setIsLoading(true);
                const preferredLanguage = getPreferredLanguage();
                await translationService.loadTranslations(preferredLanguage);
            } catch (error) {
                console.error('Failed to initialize translations:', error);
                setError(error);
            } finally {
                setIsLoading(false);
            }
        };

        initializeLanguage();

        // Listen for language changes
        const handleLanguageChange = () => {
            const newLanguage = getPreferredLanguage();
            translationService.loadTranslations(newLanguage);
        };

        window.addEventListener('languagechange', handleLanguageChange);

        return () => {
            window.removeEventListener('languagechange', handleLanguageChange);
        };
    }, []);

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error loading translations</div>;
    }

    return (
        <div className='App'>
            <main>
                <Outlet />
            </main>
        </div>
    );
}
